import BaseCellHandler from './BaseCellHandler';
import TrendingWordsWrapper from '@/views/storyboard/charts/trending';
import {
    AggregationsChartData, MetricAggregationChartData,
    MetricTimelineAggregatedChartData,
    MetricTimelineHistogramChartData, MultiTermsTimelineChartData, TermsTimelineChartData,
    TimelineByDateChartData
} from 'entities/chartData';


export type TrendingWordsChartData = (
    TimelineByDateChartData
    | AggregationsChartData
    | TermsTimelineChartData
    | MultiTermsTimelineChartData
    | MetricTimelineAggregatedChartData
    | MetricTimelineHistogramChartData
    | MetricAggregationChartData
);

class TrendingWordsCellHandler extends BaseCellHandler {
    endpointUrl = window.URLS.getTrendingWords;

    renderContent() {
        const {data, queryDuration} = this.state;
        const {
            chartQuery, chartId, chartTitle, scalingFactor, chartSettingsView,
        } = this.props;

        return (
            <TrendingWordsWrapper
                data={data! as TrendingWordsChartData[]}
                chartId={chartId}
                chartQuery={chartQuery}
                chartTitle={chartTitle}
                scalingFactor={scalingFactor}
                queryDuration={queryDuration}
                chartSettingsView={chartSettingsView}
            />
        );
    }
}

export default TrendingWordsCellHandler;
